import { render, staticRenderFns } from "./participant-monitor-new-card.vue?vue&type=template&id=e0df1364&scoped=true&"
import script from "./participant-monitor-new-card.vue?vue&type=script&lang=ts&"
export * from "./participant-monitor-new-card.vue?vue&type=script&lang=ts&"
import style0 from "./participant-monitor-new-card.vue?vue&type=style&index=0&id=e0df1364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0df1364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
